import { render, staticRenderFns } from "./LeaveRequestsUserTransaction.vue?vue&type=template&id=a78b9fa4&scoped=true&"
import script from "./LeaveRequestsUserTransaction.vue?vue&type=script&lang=js&"
export * from "./LeaveRequestsUserTransaction.vue?vue&type=script&lang=js&"
import style0 from "./LeaveRequestsUserTransaction.vue?vue&type=style&index=0&id=a78b9fa4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a78b9fa4",
  null
  
)

export default component.exports